// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
// Handlers
import { SuccessHandlers } from '../handlers/success.handlers';
// Types
import { SuccessHookType } from './types/success.hook.type';

const useSuccessHook = (): SuccessHookType => {
  const { callbackUrl, loanId, customerName, currentState } = useAppContextConsumerHook();

  const { handleRedirectSuccessToAmazonButtonClick } = SuccessHandlers({ callbackUrl, loanId });

  return { customerName, currentState, handleRedirectSuccessToAmazonButtonClick };
};

export { useSuccessHook };
